// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState } from '../../../core/reducers/';
import { isLoggedIn } from '../_selectors/auth.selectors';
import { TokenStorage } from '../_services/token-storage.service';
import * as jwt_decode from 'jwt-decode';
import { AuthService } from '../_services/auth.service';
@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router, private tokenStorage: TokenStorage, private service: AuthService) { }


    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (await this.tokenStorage.getAccessToken().toPromise() && this.isTokenExpired()) {
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
        return false;
    }

    getToken(): string {
        let user = JSON.parse(localStorage.getItem("UserInfo"));
        return user.accessToken;
    }

    getTokenExpirationDate(token: string): Date {
        // token = atob(token);
        const decoded = jwt_decode(token);
        if (decoded.exp === undefined) return null;
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    async isTokenExpired(token?: string):  Promise<boolean> {
        if (!token) token = this.getToken();
        if (!token) return false;
        const date = this.getTokenExpirationDate(token);
        if (date === undefined) return false;
        var time = await this.service.getCurrentTime().toPromise();
        return time ? (date.getTime() >= time) : false;
    }
}
